import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _values from "lodash/values";

import { QUESTION_FLOW, ROLE_TYPE_MAP } from "lib/constants";
import { questionProps } from "lib/propTypes";
import { questionSetFilter } from "redux/questions/actions";

class PrefRoleQuestion extends React.PureComponent {
    static propTypes = {
        ...questionProps,
        flow: PropTypes.oneOf(_values(QUESTION_FLOW)).isRequired,
        handleAnswer: PropTypes.func.isRequired,
        questionSetFilter: PropTypes.func.isRequired,
    };

    onChange = () => {
        let roles = 0;

        // IE11 doesn't support NodeList.forEach
        const checked = this.list.querySelectorAll("input:checked");
        for (let i = 0; i < checked.length; i += 1) {
            roles |= ROLE_TYPE_MAP[Number(checked[i].value)];
        }

        this.props.handleAnswer({
            canSubmit: !!roles,
            questionID: this.props.id,
            response: roles,
        });

        if (this.props.flow === QUESTION_FLOW.ONBOARD) {
            // Filter the remaining role-specific questions
            this.props.questionSetFilter({
                filter: "roleType",
                value: roles,
            });
        }
    };

    renderOptions() {
        return this.props.answer.map((a) => (
            <li key={a.id}>
                <input
                    id={`pref_role_${a.id}`}
                    type="checkbox"
                    value={a.id}
                    onChange={this.onChange}
                />
                <label htmlFor={`pref_role_${a.id}`} className="questions__list-label">
                    {a.value}
                </label>
            </li>
        ));
    }

    render() {
        return (
            <div>
                <label className="questions__title">{this.props.question}</label>
                <p className="questions__sublabel">Select all that apply</p>
                <ul className="checkbox-list questions__list" ref={(c) => (this.list = c)}>
                    {this.renderOptions()}
                </ul>
            </div>
        );
    }
}

export default connect(null, { questionSetFilter })(PrefRoleQuestion);
